const TYPES = {
  AUTH: "AUTH",
  ALERT: "ALERT",
  LOGOUT: "LOGOUT",
  OTP: "OTP",
  EDIT_PROFILE: "EDIT_PROFILE",
};

export default TYPES;
